// extracted by mini-css-extract-plugin
module.exports = {"block":"style__block__+QzYl","children":"style__children__aq8BN","sections":"style__sections__CRa1p","buttons":"style__buttons__hLWV1","dates":"style__dates__wrzP5"};